import { Card } from "@/components/ui/card"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"
import { Clock, Eye, AlertTriangle, HelpCircle, XCircle } from "lucide-react"

const triedSolutions = [
  {
    solution: "Встроенная аналитика системы поддержки",
    problem: "Слишком базовая. Просто считает количество, не понимает контекст",
  },
  {
    solution: "Ручной анализ в таблицах",
    problem: "Занимает 8+ часов в неделю. Невозможно масштабировать",
  },
  {
    solution: "Нанять аналитика",
    problem: "Слишком дорого для нашей стадии — $80,000/год",
  },
  {
    solution: "Читать случайную выборку",
    problem: "Пропускаем критические проблемы",
  },
]

export function ProblemSection() {
  return (
    <section className="bg-background section-padding-y border-b">
      <div className="container-padding-x container mx-auto flex flex-col gap-10 md:gap-12">
        <div className="section-title-gap-lg mx-auto flex max-w-xl flex-col items-center text-center">
          <Tagline>Проблема</Tagline>
          <h2 className="heading-lg">Знакомо?</h2>
        </div>

        {/* Story */}
        <div className="mx-auto max-w-3xl">
          <Card className="bg-muted/30 border-none p-6 shadow-none lg:p-8">
            <div className="flex flex-col gap-6">
              <div className="flex items-start gap-4">
                <div className="bg-primary/10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                  <Clock className="text-primary h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-foreground mb-2 font-semibold">Типичный понедельник</h3>
                  <p className="text-muted-foreground">
                    Вы открываете систему поддержки и видите 300+ новых обращений за неделю. После двух часов чтения —
                    прочитано только 40. К обеду — 80 из 300. Остальные 220 остаются на "как-нибудь потом".
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                  <Eye className="text-primary h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-foreground mb-2 font-semibold">Неполная картина</h3>
                  <p className="text-muted-foreground">
                    На встрече команды показываете "главные проблемы" на основе 27% выборки. Команда принимает решения
                    на неполных данных.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-destructive/10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full">
                  <AlertTriangle className="text-destructive h-5 w-5" />
                </div>
                <div>
                  <h3 className="text-foreground mb-2 font-semibold">Последствия</h3>
                  <p className="text-muted-foreground">
                    Через месяц выясняется: вы пропустили критический баг, который был в тех непрочитанных письмах. 30
                    клиентов ушли.
                  </p>
                </div>
              </div>
            </div>
          </Card>

          {/* Quote */}
          <blockquote className="mt-8 border-l-4 border-primary pl-6">
            <p className="text-foreground text-lg italic">
              "Я постоянно чувствую, что отстаю. Что упускаю что-то важное. И не могу ничего с этим сделать."
            </p>
            <footer className="text-muted-foreground mt-2 text-sm">
              — Продакт-менеджер, SaaS-стартап на 50 человек
            </footer>
          </blockquote>
        </div>

        {/* What you've tried */}
        <div className="mx-auto w-full max-w-4xl">
          <div className="mb-6 flex items-center justify-center gap-2">
            <HelpCircle className="text-muted-foreground h-5 w-5" />
            <h3 className="text-foreground text-lg font-semibold">Что вы уже пробовали</h3>
          </div>
          <div className="grid gap-4 md:grid-cols-2">
            {triedSolutions.map((item, index) => (
              <Card key={index} className="bg-muted/30 border-none p-4 shadow-none">
                <div className="flex items-start gap-3">
                  <XCircle className="text-muted-foreground mt-0.5 h-5 w-5 shrink-0" />
                  <div>
                    <h4 className="text-foreground mb-1 font-medium">{item.solution}</h4>
                    <p className="text-muted-foreground text-sm">{item.problem}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
